<template>
    <form-wrapper @form-submit="submit">
        <form-row>
            <form-cell>
                <text-input
                    :formData="data"
                    :label="$t('forms.user.verify_phone.fields.token.label')"
                    :placeholder="$t('forms.user.verify_phone.fields.token.placeholder')"
                    :isRequired="true"
                    type="text"
                    valuePath="token"
                    @change="change"
                ></text-input>
            </form-cell>
        </form-row>
        <form-row>
            <form-cell>
                <div v-if="isResendDisabled" class="sms_countdown">
                    {{ $t('forms.user.verify_phone.smsSent', { n: countdownSeconds }) }}
                </div>
                <common-buttons>
                    <common-button
                        type="link"
                        size="tiny-micro"
                        :isDisabled="isResendDisabled"
                        :isSubmittable="false"
                        :label="$t('forms.user.verify_phone.buttons.resend')"
                        @click="resendCode()"
                    ></common-button>
                </common-buttons>
            </form-cell>
        </form-row>

        <template #footer>
            <common-buttons>
                <common-button
                    type="primary"
                    :isProcessing="isLoading"
                    :label="$t('forms.user.verify_phone.buttons.save')"
                ></common-button>
            </common-buttons>
        </template>
    </form-wrapper>
</template>

<script>
    import FormMixin from 'mixins/FormMixin'
    import UsersAPI from 'api/UsersAPI'

    export default {
        mixins: [FormMixin],

        props: {
            isSmsSent: { type: Boolean, default: false },
        },

        data() {
            return {
                isResendDisabled: false,
                countdownSeconds: 30,
                countdownInterval: null,
            }
        },

        methods: {
            submit() {
                this.submitForm(
                    UsersAPI.verifyPhone({ token: this.data.token }).then(() => {
                        this.$auth.reloadUser()
                    }),
                ).catch((error) => {
                    this.handleError(error)
                })
            },

            resendCode() {
                UsersAPI.changePhone({ mobile: this.$auth.getUser().pendingMobile })
                    .then(() => {
                        this.startCountdown()
                        this.$toast.success(this.$t('common.microcopy.success'))
                    })
                    .catch((error) => {
                        this.handleError(error)
                    })
            },

            handleError(error) {
                if (error.statusCode === 400) {
                    this.$toast.error(this.$t(`validations.${error.error.message}`))
                }
            },

            startCountdown() {
                this.isResendDisabled = true
                this.countdownInterval = setInterval(() => {
                    if (this.countdownSeconds > 0) {
                        this.countdownSeconds -= 1
                    } else {
                        clearInterval(this.countdownInterval)
                        this.isResendDisabled = false
                        this.emitEvent({ name: 'sms-countdown-over' })
                        this.countdownSeconds = 30
                    }
                }, 1000)
            },
        },

        mounted() {
            if (this.isSmsSent) {
                this.startCountdown()
            }
        },
    }
</script>

<style lang="scss" scoped>
    .sms_countdown {
        text-align: center;
        margin-bottom: 10px;
    }
</style>
